var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2451_64041)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.219144 1.02377C0.0784452 1.17192 -3.33543e-07 1.36845 -3.24612e-07 1.57277C-3.15681e-07 1.77709 0.0784452 1.97361 0.219144 2.12177L6.41714 8.54402C6.55377 8.68778 6.7182 8.80225 6.90045 8.88047C7.08269 8.95869 7.27894 8.99902 7.47727 8.99902C7.67559 8.99902 7.87184 8.95869 8.05409 8.88047C8.23634 8.80225 8.40077 8.68778 8.53739 8.54402L14.7811 2.07527C15.0699 1.77527 15.0736 1.28927 14.7886 0.984766C14.7207 0.911045 14.6384 0.852068 14.5468 0.811498C14.4551 0.770928 14.3561 0.74963 14.2559 0.748926C14.1557 0.748224 14.0564 0.76813 13.9642 0.80741C13.872 0.84669 13.7888 0.904505 13.7199 0.977266L8.00714 6.89702C7.93883 6.96895 7.85659 7.02624 7.76543 7.06538C7.67427 7.10453 7.5761 7.12472 7.47689 7.12472C7.37769 7.12472 7.27952 7.10453 7.18836 7.06538C7.0972 7.02624 7.01496 6.96895 6.94664 6.89702L1.27889 1.02452C1.21064 0.952599 1.12847 0.895328 1.03737 0.856191C0.946275 0.817054 0.848166 0.796871 0.749019 0.796871C0.649871 0.796871 0.551762 0.817054 0.460666 0.856191C0.369569 0.895328 0.287394 0.951849 0.219144 1.02377Z",
    fill: "#252730"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2451_64041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.25,
    height: 15,
    fill: "white",
    transform: "translate(0 9) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.656b20710bed69a5e06d25549914dd25.svg";
export { ForwardRef as ReactComponent };